var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
// Microscopekit components
import { compose, graphql, GrayText, Grid, GridColumn, PageLayout, RightDiv, Separator, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag } from "@atlassiansox/microscopekit";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
// GraphQL queries
import serviceQuery from "../graphql/service.query.graphql";
import Tabs from "@atlaskit/tabs";
import SectionMessage from "@atlaskit/section-message";
import { ActiveWargameForService, CronosRecentWargamesListView } from "../components";
import { CronosConfigsListView } from "../components/ListView/CronosConfigsListView";
import { useWargamesWithFilters } from "../hooks";
import { SortOrder } from "../graphql";
import { NotificationHeader } from "../components/NotificationHeader";
var CronosPageView = function (props, context) {
    var _a = useWargamesWithFilters({
        service: {
            eq: props.id
        },
        trigger: {
            in: ["cronos"]
        }
    }, 10, 0, "id", SortOrder.DESC), getData = _a.getData, wargamesWithFilters = _a.wargamesWithFilters, pageCount = _a.pageCount, isWargameWithFiltersLoading = _a.isLoading;
    var _b = __read(useState(0), 2), selectedTabIndex = _b[0], setSelectedTabIndex = _b[1];
    var tabs = [
        {
            label: "Active Executions",
            content: (React.createElement(ActiveWargameForService, { serviceId: props.id, isVisible: selectedTabIndex === 0, trigger: "cronos" }))
        },
        {
            label: "Previous Executions",
            content: (React.createElement(CronosRecentWargamesListView, { serviceId: props.id, serviceWargamesData: wargamesWithFilters !== null && wargamesWithFilters !== void 0 ? wargamesWithFilters : [], pageCount: pageCount, isLoading: isWargameWithFiltersLoading !== null && isWargameWithFiltersLoading !== void 0 ? isWargameWithFiltersLoading : false, isFilterAvailable: true, trigger: "cronos", getData: getData }))
        }
    ];
    return (React.createElement(PageLayout, { title: "" },
        React.createElement("h2", null, "Continuous Chaos"),
        React.createElement("div", null,
            React.createElement(GrayText, null, "Continuous Chaos is supported only for servcies onboarded to Micros Platform")),
        React.createElement(Separator, null),
        React.createElement(Grid, null,
            React.createElement(GridColumn, { medium: 12 },
                React.createElement(RightDiv, null,
                    React.createElement(NotificationHeader, { serviceId: props.id })))),
        React.createElement("br", null),
        React.createElement(SectionMessage, null,
            "Refer\u00A0",
            React.createElement("a", { href: "http://go/continuous-chaos", target: "_blank", rel: "noopener noreferrer" }, "http://go/continuous-chaos"),
            "\u00A0for onboarding to continuous-chaos"),
        React.createElement(CronosConfigsListView, { serviceId: props.id }),
        React.createElement(Tabs, { tabs: tabs, isContentPersisted: true, selected: selectedTabIndex, onSelect: function (tab, index) { return setSelectedTabIndex(index); } })));
};
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export var CronosPage = compose(graphql(serviceQuery, {}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("Credo.CredoPage"))(CronosPageView);
